export default __webpack_public_path__ + "static/media/socials.0a0b1a44.webp";